import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  config: {},
  landingConfig: null,
  visibleSections: [],

  loading: true,
  error: true,
};

const configSlice = createSlice({
  name: "configSlice",
  initialState,
  reducers: {
    saveConfig: (state, action) => {
      state.config = action.payload.data;
      state.loading = false;
      state.error = false;
    },
    saveLandingConfig: (state, action) => {
      state.landingConfig = action.payload.landingConfig;
      state.visibleSections = action.payload.visibleSections;
    },
    removeConfig: (state, action) => {
      state.config = {};
      state.loading = true;
      state.error = true;
    },
  },
});

export const { saveConfig, removeConfig, saveLandingConfig } = configSlice.actions;
export default configSlice.reducer;
